import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var membershipIcon = /*#__PURE__*/React.createElement("svg", {
  height: "22",
  width: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.964 10.241h-9.195l8.63-8.629a.74.74 0 0 0 0-1.047l-.524-.523-9.152 9.153V.74a.741.741 0 0 0-.741-.74h-.741v9.195L5.93 4.883a.74.74 0 0 0-1.047 0l-.523.523 4.834 4.835H.74a.741.741 0 0 0-.74.741v.74h9.194L.487 20.429a.74.74 0 0 0 0 1.047l.524.524 9.23-9.231v8.429c0 .409.332.741.741.741h.741v-9.17l4.326 4.327a.74.74 0 0 0 1.048 0l.522-.523-4.85-4.851h8.455a.74.74 0 0 0 .74-.74v-.741Z",
  fill: "currentColor"
}));

export { membershipIcon as default };
//# sourceMappingURL=membershipIcon.js.map
